import { Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';
const AccessDenied = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <h1>403</h1>
      <h2>Nie masz uprawnień do tej strony</h2>
      <p>Skontaktuj się z administratorem, jeśli potrzebujesz dostępu.</p>
      <Button
        sx={{ bgcolor: '#C09A53', ':hover': { bgcolor: '#9c7c43' } }}
        variant="contained"
        component={Link}
        to="/"
      >
        Wróć na stronę główną
      </Button>
    </Box>
  );
};
export default AccessDenied;
